<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      摄像机
    </div>
    <div style="padding: 20px;">

      <div>

        <el-row>
          <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
          <div style="float:right">
            <el-input placeholder="请输入名称" v-model="name" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>


            <el-select
                v-model="status"
                placeholder="请选择状态">
              <el-option
                  v-for="item in statusValue"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          </div>
        </el-row>
        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>

          <el-table :data="tableData" :height="th" border style="width: 100%;">

            <el-table-column prop="name" label="设备名称"></el-table-column>

            <el-table-column prop="uid" label="设备序列号"></el-table-column>

            <el-table-column  :formatter="getTime" label="添加时间"></el-table-column>


            <el-table-column
                prop="Status"
                :formatter="statusTitle"
                label="状态">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="250">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button :loading="loading" type="success"  size="small" @click="preview(scope.$index, scope.row)">预览</el-button>
                <el-button :loading="loading" type="warning"  size="small" @click="playback(scope.$index, scope.row)">回放</el-button>
              </template>
            </el-table-column>

          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <Preview ref="myPreview" v-show="showModalPreview" v-on:closePreview="closePreview"   v-on:getList="getList"      ></Preview>
    <Playback ref="myPlayback"  v-show="showModalPlayback"  v-on:closePlayback="closePlayback"  v-on:getList="getList"   ></Playback>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode} from "@/utils/auth";
import Preview from "@/views/deviceMgr/VideoCamera/Preview";
import Playback from "@/views/deviceMgr/VideoCamera/Playback";

export default {
  name: "Role",
  data(){
    return{
      showModalPlayback:false,
      showModalPreview:false,
      loading:false,
      name:'',
      showModalAdd:false,
      showModalEdit:false,
      searchDishes:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
      status:-1,
      statusValue:[{name:'全部状态',value:-1},{name:'默认',value:0},{name:'正常',value:1},{name:'禁用',value:2}],
      createTime:''


    }
  },
  components:{
    Preview,Add,Edit,Playback
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closePreview:function (){
      this.showModalPreview =!this.showModalPreview;
    },
    closePlayback:function(){
      this.showModalPlayback=!this.showModalPlayback;
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getTime(row){
      var  a =row.createTime.substr(0,10);
      var  b =row.createTime.substr(11,8);

      return a+"\n"+b;
    },
    statusTitle(row){
      if(row.status === 0){
        return "默认";
      }
      if(row.status === 1){
        return "正常";
      }
      if(row.status === 2){
        return "禁用";
      }
      return "其它";
    },
    getList(){

      this.$axios({
        method: 'post',
        url: this.$institutionUrl+"VideoCamera/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          status:this.status,
          name:this.name,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    preview(index,row){
      this.$refs.myPreview.init(row);
      this.showModalPreview = !this.showModalPreview;
    },
    playback(index,row){
      this.$refs.myPlayback.init(row);
      this.showModalPlayback = !this.showModalPlayback;
    }



  }
}
</script>

<style scoped>

</style>
